import { memo } from 'react';

import { SvgIcon } from '@material-ui/core';

import { colors } from '../theme';
import { SvgIconProps } from './SvgIcon.types';

export const CheckMarkIcon = memo(({ color = colors.secondary.main, fontSize = 16, ...rest }: SvgIconProps) => {
  return (
    <SvgIcon width="27" height="27" viewBox="0 5 27 27" fill="none" style={{ fontSize }} {...rest}>
      <path
        d="M9.21289 23.3824C8.79223 23.3824 8.37645 23.2269 8.06137 22.9238L3.17837 18.2261C2.54251 17.6152 2.54251 16.623 3.17837 16.0121C3.81422 15.4004 4.84393 15.4004 5.47978 16.0121L9.40616 19.7894L21.2665 11.9574C22.0071 11.4683 23.0206 11.6496 23.5289 12.3621C24.0381 13.0754 23.8497 14.0496 23.1083 14.5394L10.1338 23.1074C9.85361 23.2918 9.53284 23.3824 9.21289 23.3824Z"
        fill={color}
      />
    </SvgIcon>
  );
});
